define(function(require,exports,module){
    var vendor = require( 'Responsive/vendor' ),
        domHelper = require( '../helpers/domHelper' ),
        RenderCanvas= require( './Canvas' ),
        Scaler = require('../helpers/Scaler'),
        gcd = require( '../math/gcd' ),
        config = require( '../enums/config' ),
        cssClass = require( '../helpers/cssClass' );

    var lineCap = "round",
        lineJoin = "miter",
        xmlns="http://www.w3.org/2000/svg";

    function RenderSVG(pitchLayer){
        var scalers=this.scalers=pitchLayer.scalers;
        this.pitchLayer=pitchLayer;

        this.svg = document.createElementNS(xmlns,'svg');
        this.svg.setAttributeNS(null,'class',cssClass("svg"));
        this.svg.setAttributeNS(null,'viewBox','0 0 ' + scalers.base_width + ' ' + scalers.base_height);
        this.svg.setAttributeNS(null,'version','1.1');
        this.svg.setAttributeNS(null,'width',"100%");
        this.svg.setAttributeNS(null,'height',"100%");
        this.svg.setAttributeNS(null,'x',"0");
        this.svg.setAttributeNS(null,'y',"0");

        this.ballTemplate = document.createElement('circle');
        this.defs = document.createElement('defs');
        this.container = document.createElement('g');
        this.svg.appendChild(this.defs);
        this.svg.appendChild(this.container);
        this.svg.style.opacity=1;
    }

    RenderSVG.prototype={
        isCanvas          : false,
        isVector          : true,
        isStrikeZoneDrawn : false,
        hidden          : true,
        anchor          : function(){
            domHelper.append(this.pitchLayer.view,this.svg);
        },
        destroy         : function(){
            this.isStrikeZoneDrawn=false;
            domHelper.remove(this.svg);
        },
        resize          : function(){
            // this.svg.setAttributeNS(null,'viewBox','0 0 ' + this.scalers.width + ' ' + this.scalers.height);
        },

        draw2Dpitch : function (pitch) {
            var scalers=this.scalers;
            var that=this;

            if (!this.isStrikeZoneDrawn) {
                this.draw2DStrikeZone(pitch);
            }

            if (scalers.mode === '2d' && pitch.pitch.is3DPitch) {
                this.pitchLayer.drawBall(pitch, pitch.getArrayOfPointsForPitch(1).slice(-1)[0]);
                return;
            }

            this.pitchLayer.drawBall(pitch,pitch.raster.points2D());
        },

        drawPitch : function (pitch) {
            var that=this,
                scalers=this.scalers;

            if (this.scalers.mode === '2d' || !pitch.pitch.is3DPitch) {
                // this.draw2Dpitch(pitch);
                return;
            }
            if (!this.isStrikeZoneDrawn) {
                // this.drawStrikeZone(pitch);
            }
            // 3D Perspective Path
            this.drawPitchPath(pitch);
        },
        drawBall : function (pitch, pt) {
            if(config.domBalls || true){
                return;
            }
            var that=this,
                scalers=this.pitchLayer.scalers,
                color = pitch.shader.ball,
                s_offset = 2 / scalers.base_width * scalers.x,
            //grad,
                fsize = ( 70 / scalers.base_width * scalers.fakeBallSize).toFixed(2),
                font = 'bold ' + fsize + 'em ' + config.font,
                lineWidth = pt[4] || 0;

            this.gtx_fg.globalAlpha(1)
                .globalCompositeOperation("source-over")
                .beginPath()
                .arc(pt[0], pt[1] + scalers.fakeBallSize / 2, scalers.fakeBallSize, 0, (Math.PI / 180) * 360, true)
                .shadow({
                    offsetX: s_offset,
                    offsetY: s_offset,
                    blur: 4
                })
                .stroke({
                    style: pitch.shader.ballStroke
                })
                .shadowColor('transparent')
                .lineWidth(scalers.canvasDensity > 1 ? scalers.canvasDensity : 1);

            /* Commenting out gradient calc for now, as flatter styles are desired. Consider this a
             memorial for our gradient friends (also, I'm sure we'll be bringing this back soon) */

            // grad = gtx.createRadialGradient(pt[0] - scalers.fakeBallSize / 2, pt[1] - scalers.fakeBallSize / 2, 1, pt[0], pt[1] + scalers.fakeBallSize, scalers.fakeBallSize * (consts.canvasDensity > 1 ? consts.canvasDensity : 1) * 2);
            // grad.addColorStop(0, color.replace(regexColor, colorShiftLight));
            // grad.addColorStop(0.4, color);
            // grad.addColorStop(1, color.replace(regexColor, colorShift));

            /* Fill solid first to avoid transparency bug in Android */
            this.gtx_fg.fillStyle(color)
                .fill()
                //.fillStyle(grad)
                //.fill()
                .stroke()
                .closePath()
                .beginPath()
                //.shadowColor(colors.shadow)
                .font(font)
                .fillStyle(pitch.shader.text)
                .shadow({
                    offsetX: scalers.canvasDensity,
                    offsetY: scalers.canvasDensity,
                    blur: 1
                })
                .text({
                    align: "center",
                    baseline: "middle"
                })
                .fillText(pitch.num + "", pt[0], pt[1] + scalers.fakeBallSize / 2)
                .closePath();
                if (that.pitchLayer.type !== "side") {
                    // Adding delay for rendering of visualization
                    // setTimeout(function () {
                    //     MessageService.publish('pitch_thrown', {
                    //         atbat: that.pitchLayer.atbat,
                    //         pitch: p,
                    //         pitches: that.pitchLayer.pitches
                    //     });
                    // }, 1000);
                }

        },

        drawPitchStart : function (pt) {
            this.gtx_bg.beginPath()
                .lineWidth(1)
                .strokeStyle(colors.text)
                .arc(pt[0], pt[1], 6, 0, (Math.PI / 180) * 360, false)
                .stroke()
                .closePath();
        },

        drawPitchPath : function (pitch) {
            var that=this,
                points=pitch.vector.curve(),
                path = document.createElementNS(xmlns,'path');
            var pathStroke = pitch.shader.getGradient();
            if(pathStroke.id){
                this.defs.appendChild(pathStroke);
            }
            path.setAttribute('d',points);
            path.setAttribute('stroke',pitch.shader.pathStroke);
            path.setAttribute('fill',"none");
            path.setAttribute('stroke-width',10)//pitch.vector.width());
            // path.setAttribute('transform','translate(100,100)')
            domHelper.append(this.container,path);
            console.dir(path)
        },

        drawHistory : function(){
            if(config.fadeOldPitches && this.canvas_history){
                this.pitchLayer.scheduler.addAction(function () {
                    this.gtx_history.drawImage(this.canvas_bg,0,0);
                    this.gtx_bg.drawImage(this.canvas_bg,0,0);

                    this.canvas_bg.width = this.canvas_bg.width;
                    this.gtx_bg.beginPath()
                        .clearRect(0, 0, this.canvas_bg.width, this.canvas_bg.height)
                        .closePath();

                    this.gtx_bg.beginPath()
                        .fillStyle("rgba(0,0,0,0.1)")
                        .fillRect(0, 0, 1, 1)
                        .closePath();

                }, 0, this);
            }
        },
        drawStrikeZone : function (pitch) {

            var that=this,
                scalers=this.scalers,
                sz = pitch.is3DPitch ? pitch.pitch : scalers.strikeZone,
                topLeftCorner = pitch.raster.pointOnGrid(-scalers.homePlateWidth / 2, sz.szTop, -scalers.homePlateFrontY),
                bottomRightCorner = pitch.raster.pointOnGrid(scalers.homePlateWidth / 2, sz.szBot, -scalers.homePlateFrontY),
                grid = [
                    [],
                    [],
                    []
                ],
                outliers = [],
                hotColdZones = scalers.mode !== '2d' && scalers.hotColdZones && this.pitchLayer.hotcold,
                zones;

            if (!hotColdZones) {
                this.drawNOHCStrikeZone(topLeftCorner, bottomRightCorner);
                return;
            }

            var count = 0,
                i = 0,
                zones = [].concat(this.pitchLayer.hotcold.sitModel && this.pitchLayer.hotcold.sitModel.zones || []);

            this.gtx_fg.beginPath()
                .fillStyle("rgba(0,0,0,0.1)")
                .fillRect(0, 0, 1, 1)
                .closePath();

            if (!zones.length) {
                this.drawNOHCStrikeZone(topLeftCorner, bottomRightCorner);
            }
            /*
             * Populate inner strike zone data
             * leaving over outlier data for later
             */
            while (zones.length && i < 3) {
                grid[i].push({
                    data: zones.shift(),
                    temp: zones.shift()
                });

                count += 1;

                if (count === 3) {
                    i += 1;
                    count = 0;
                }
            }

            // Populate outlier zones of strike zone data
            while (zones.length) {
                outliers.push({
                    data: zones.shift(),
                    temp: zones.shift()
                });
            }

            outliers.forEach(function (e, i) {
                var x,
                    y;

                switch (i) {
                    case 0:
                        x = topLeftCorner[0] - (scalers.szBorder * 2);
                        y = topLeftCorner[1] - (scalers.szBorder * 2);
                        break;

                    case 1:
                        x = topLeftCorner[0] - (scalers.szBorder * 2) + ((bottomRightCorner[0] - topLeftCorner[0] + (scalers.szBorder * 2) * 2) / 2);
                        y = topLeftCorner[1] - (scalers.szBorder * 2);
                        break;

                    case 2:
                        x = topLeftCorner[0] - (scalers.szBorder * 2);
                        y = topLeftCorner[1] - (scalers.szBorder * 2) + ((bottomRightCorner[1] - topLeftCorner[1] + (scalers.szBorder * 2) * 2) / 2);
                        break;

                    case 3:
                        x = topLeftCorner[0] - (scalers.szBorder * 2) + ((bottomRightCorner[0] - topLeftCorner[0] + (scalers.szBorder * 2) * 2) / 2);
                        y = topLeftCorner[1] - (scalers.szBorder * 2) + ((bottomRightCorner[1] - topLeftCorner[1] + (scalers.szBorder * 2) * 2) / 2);
                        break;

                    default:
                        // do nothing
                        break;
                }

                that.gtx_fg
                    .beginPath()
                    .shadowColor("transparent")
                    .lineWidth(1)
                    .fillStyle(e.data.color)
                    .fillRect(
                    x,
                    y,
                        (bottomRightCorner[0] - topLeftCorner[0] + (scalers.szBorder * 2) * 2) / 2,
                        (bottomRightCorner[1] - topLeftCorner[1] + (scalers.szBorder * 2) * 2) / 2
                )
                    .closePath();
            });

            this.gtx_fg
                .beginPath()
                .shadowColor("transparent")
                .clearRect(
                    topLeftCorner[0] - 1,
                    topLeftCorner[1] - 1,
                    bottomRightCorner[0] - topLeftCorner[0] + 2,
                    bottomRightCorner[1] - topLeftCorner[1] + 2
            )
                .closePath();

            grid.forEach(function (row, y) {
                row.forEach(function (zone, x) {
                    var coords={};
                    ([x, this.y]).forEach(function (e, i) {
                        switch (e) {
                            case 0:
                                e = topLeftCorner[i];
                                break;

                            case 1:
                                e = topLeftCorner[i] + ((bottomRightCorner[i] - topLeftCorner[i]) / 3);
                                break;

                            case 2:
                                e = topLeftCorner[i] + (((bottomRightCorner[i] - topLeftCorner[i]) / 3) * 2);
                                break;

                            default:
                                // do nothing!
                                break;
                        }

                        i === 0 ? coords.x = e : coords.y = e;
                    });

                    that.gtx_fg
                        .beginPath()
                        .fillStyle(zone.data.color)
                        .fillRect(coords.x, coords.y, ((bottomRightCorner[0] - topLeftCorner[0]) / 3), ((bottomRightCorner[1] - topLeftCorner[1]) / 3))
                        .strokeStyle("rgba(127, 127, 127, .2)")
                        .lineWidth(2)
                        .strokeRect(coords.x, coords.y, ((bottomRightCorner[0] - topLeftCorner[0]) / 3), ((bottomRightCorner[1] - topLeftCorner[1]) / 3))
                        .closePath();
                }, { y: y });
            });

            this.isStrikeZoneDrawn = true;
        },
        drawNOHCStrikeZone : function (topLeftCorner, bottomRightCorner) {
            var scalers=this.scalers;
            this.gtx_fg.beginPath()
                .shadowColor("transparent")
                .fillStyle("rgba(255, 255, 255, 0.3)")
                .fillRect(
                    topLeftCorner[0] - scalers.szBorder,
                    topLeftCorner[1] - scalers.szBorder,
                    bottomRightCorner[0] - topLeftCorner[0] + scalers.szBorder * 2,
                    bottomRightCorner[1] - topLeftCorner[1] + scalers.szBorder * 2
            )
                .clearRect(
                    topLeftCorner[0] - 1,
                    topLeftCorner[1] - 1,
                    bottomRightCorner[0] - topLeftCorner[0] + 2,
                    bottomRightCorner[1] - topLeftCorner[1] + 2
            )
                .fillStyle("rgba(0, 0, 0, 0.5)")
                .fillRect(
                topLeftCorner[0],
                topLeftCorner[1],
                    bottomRightCorner[0] - topLeftCorner[0],
                    bottomRightCorner[1] - topLeftCorner[1]
            )
                .strokeStyle("rgba(0, 0, 0, 0.6)")
                .strokeRect(
                    topLeftCorner[0] - scalers.szBorder,
                    topLeftCorner[1] - scalers.szBorder,
                    bottomRightCorner[0] - topLeftCorner[0] + scalers.szBorder * 2,
                    bottomRightCorner[1] - topLeftCorner[1] + scalers.szBorder * 2
            )
                .closePath();

            this.isStrikeZoneDrawn = true;
        },

        draw2DStrikeZone : function (pitch) {
            this.drawStrikeZone(pitch);
        },
        getSizerURI     : function(){
            var scalers=this.pitchLayer.scalers,
                mindims = gcd(this.scalers.base_width, this.scalers.base_height),
                canvas = new RenderCanvas(this.pitchLayer),
                sizer = canvas.canvas_fg,
                img;

            canvas.canvas_fg.width = this.scalers.base_width / mindims;
            canvas.canvas_fg.height = this.scalers.base_height / mindims;

            canvas.gtx_fg.beginPath()
                .clearRect(0, 0, sizer.width, sizer.height)
                .closePath();
            // console.log(canvas,sizer)
            img=sizer.toDataURL();
            canvas.destroy();
            return img;

        },

        hideCanvas : function (cb) {
            if (this.hidden) {
                cb && cb();
                return;
            }
            this.hidden = true;
            this.canvas_bg.style.opacity = 0.1;
            this.canvas_fg.style.opacity = 0.1;
            if(this.canvas_history){
                this.canvas_history.style.opacity = 0.1;
            }
            if (cb) {
                setTimeout(cb, 500);
            }
        },

        showCanvas : function (cb) {
            if (!this.hidden) {
                cb && cb();
                return;
            }
            this.hidden = false;
            this.canvas_bg.style.opacity = 1;
            this.canvas_fg.style.opacity = 1;
            if(this.canvas_history){
                this.canvas_history.style.opacity = 0.5;
            }
            if (cb) {
                setTimeout(cb, 500);
            }

        },

        clear : function () {
            this.isStrikeZoneDrawn=false;
            this.container.innerHTML="";
            this.defs="";

            this.resize();
        },
        run : function(){
            // if(this.pitchLayer.config.renderURI){
            //     this.scheduler.addAction(this.pitchLayer.renderImage,0,this.pitchLayer);
            // }
            // this.scheduler.run();
        }
    };
    return RenderSVG;
});
